import { Fragment } from 'react';
import Slider from './slider.web';
Slider.Item = Fragment;
export default Slider;